import { sql, type SQL } from "drizzle-orm";
import type { AnyPgColumn } from "drizzle-orm/pg-core";

export function normalizeOrderDir(raw: unknown): "asc" | "desc" {
  const d = typeof raw === "string" ? raw.toLowerCase() : "";
  return d === "asc" ? "asc" : "desc";
}

export function encodeCursor(values: unknown[], direction: "asc" | "desc"): string {
  const payload = { v: values, d: direction };
  const json = JSON.stringify(payload);
  return Buffer.from(json, "utf8").toString("base64url");
}

export function decodeCursor(token: string): { values: unknown[]; direction: "asc" | "desc" } {
  let json: string;
  try {
    json = Buffer.from(token, "base64url").toString("utf8");
  } catch {
    throw new Error("Invalid cursor");
  }
  let parsed: unknown;
  try {
    parsed = JSON.parse(json);
  } catch {
    throw new Error("Invalid cursor");
  }
  if (!parsed || typeof parsed !== "object") throw new Error("Invalid cursor");
  const { v, d } = parsed as { v?: unknown; d?: unknown };
  if (!Array.isArray(v)) throw new Error("Invalid cursor");
  const direction = d === "asc" ? "asc" : "desc";
  return { values: v, direction };
}

export function buildTupleComparePredicate(
  columns: AnyPgColumn[],
  values: unknown[],
  direction: "asc" | "desc",
): SQL {
  if (columns.length !== values.length || columns.length === 0) {
    throw new Error("cursor column count mismatch");
  }
  const opToken = direction === "asc" ? sql`>` : sql`<`;
  const colTuple = sql.join(
    columns.map((c) => sql`${c}`),
    sql`, `,
  );
  const valTuple = sql.join(
    values.map((val) => sql`${val}`),
    sql`, `,
  );
  return sql`(${colTuple}) ${opToken} (${valTuple})`;
}
